import { useEffect, useState } from 'react';

const FAVORITES_KEY = 'wedding_vendor_favorites';

export function useFavorites() {
    const [favorites, setFavorites] = useState<string[]>(() => {
        try {
            const saved = localStorage.getItem(FAVORITES_KEY);
            return saved ? JSON.parse(saved) : [];
        } catch {
            return [];
        }
    });

    useEffect(() => {
        localStorage.setItem(FAVORITES_KEY, JSON.stringify(favorites));
    }, [favorites]);

    const addFavorite = (vendorId: string) => {
        setFavorites((prev) => (prev.includes(vendorId) ? prev : [...prev, vendorId]));
    };

    const removeFavorite = (vendorId: string) => {
        setFavorites((prev) => prev.filter((id) => id !== vendorId));
    };

    const toggleFavorite = (vendorId: string) => {
        if (favorites.includes(vendorId)) {
            removeFavorite(vendorId);
        } else {
            addFavorite(vendorId);
        }
    };

    const isFavorite = (vendorId: string) => favorites.includes(vendorId);

    return { favorites, addFavorite, removeFavorite, toggleFavorite, isFavorite };
}
